<template>
  <div class="voice-text">
    <p class="fac-point">
      <kcs-rating :rating="rating" />
    </p>
    <p class="voice-comment">
      {{ comment }}
    </p>
  </div>
</template>

<script>
import KcsRating from '@/components/atoms/kcs-rating.vue'

export default {
  components: {
    KcsRating
  },
  props: {
    rating: {
      type: Number,
      default: 5.0
    },
    comment: {
      type: String,
      default: ''
    }
  }
}
</script>
